export const setStore = (store) => {
  window.localStorage.setItem('store', JSON.stringify(store));
};

export const getStore = () => {
  return JSON.parse(window.localStorage.getItem('store'));
};

export const resetStore = () => {
  window.localStorage.removeItem('store');
};

export const setLogin = (loginObject) => {
  window.localStorage.setItem('loggedIn', JSON.stringify(loginObject));
};

export const getLogin = () => {
  return JSON.parse(window.localStorage.getItem('loggedIn'));
};

export const removeLogin = () => {
  window.localStorage.removeItem('loggedIn');
};



// WEBPACK FOOTER //
// ./src/functions/storage.js